<mat-sidenav-container class="main-container">
  <!-- Menu Drawer -->
  <mat-sidenav #drawer id="drawer">
    <app-menu-drawer
      [drawerRef]="drawer"
      [routesData]="routeData"
      [systemRoutesData]="systemRouteData"
    ></app-menu-drawer>
  </mat-sidenav>
  <!-- Content -->
  <mat-sidenav-content style="display: flex; flex-direction: column">
    <app-toolbar
      class="app-toolbar"
      [drawerSideNav]="drawer"
      [notificationDrawerSideNav]="notificationDrawer"
    ></app-toolbar>
    <div class="router-container">
      <router-outlet/>
    </div>
  </mat-sidenav-content>
  <!-- Notification Drawer -->
  <mat-sidenav position="end" #notificationDrawer id="notificationDrawer">
    <app-notification-drawer
      [drawerRef]="notificationDrawer"
    ></app-notification-drawer>
  </mat-sidenav>
</mat-sidenav-container>
